export default __webpack_public_path__ + "static/media/icon-3.83b1fd61.png";